import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 2EAC4201-2055-4755-84A9-958FDDF7732B
 * name auto-download
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/auto-download.svg
 * tags
 */
export const AutoDownloadIcon = createSvgIcon(<><path d="M22 17V19H11V17H22M19 4.5V9.5H22L16.5 15L11 9.5H14V4.5H19M10.7 15H8.8L8.1 13H4.9L4.2 15H2.3L5.5 6H7.5L10.7 15M7.65 11.65L6.5 8L5.35 11.65H7.65Z" /></>, 'AutoDownloadIcon');
export default AutoDownloadIcon